/** @format */

import axiosInstance from './axios';
export async function getUserDetails(payload) {
  return await axiosInstance.post('/api/fetch_parameters', payload);
}

// each individual kpi card.
export async function getKPI(kpi, slot, payload) {
  return axiosInstance.post(
    `/flash_api/v2.3/kpi/?name=${kpi}&slot=${slot}`,
    payload
  );
}
export async function getPerformance(kpi, slot, payload) {
  return axiosInstance.post(
    `/fnb_perfomance_api/v2.3/?name=${kpi}&slot=${slot}`,
    payload
  );
}

export async function getCompPerformance(kpi, slot, payload) {
  return axiosInstance.post(
    `/comp_set_performance/api/v2.3/?name=${kpi}&slot=${slot}`,
    payload
  );
}

export async function getRevBudget(kpi, slot, payload) {
  return await axiosInstance.post(
    `/flash_api/v2.3/kpi/?name=${kpi}&slot=${slot}`,
    payload
  );
}

export async function getBookingPace(payload) {
  return await axiosInstance.post(`/booking_pace_rooms/api/v2.3/`, payload);
}

export async function getMaxDate() {
  return await axiosInstance.get(`flash_page/get_max_date/`);
}

export async function getPerformanceMaxDate() {
  return await axiosInstance.get(`flash_page/get_max_date_str/`);
}

export async function getBARLine(payload) {
  return await axiosInstance.post(`/rate_shop/chart/`, payload);
}

// leaderboard
export async function getTopPerformers(payload, query) {
  const { vector = 'sales', attribute, sorting = 'top', count = 5 } = query;
  const response = await axiosInstance.post(
    `/api/v2.4/dynamic/charts/?vector=${vector}&attribute=${attribute}&${sorting}=${count}`,
    payload
  );
  return response;
}
